<template>

  <div>

    <div class="ui large breadcrumb">
      <a class="clickable" @click="goBack()">
        <i class="reply icon m-r-5"></i> Grupos
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>{{ isCreating ? creatingTitle : updatingTitle }}</strong>
      </div>
    </div>

    <bookmark-button v-if="isCreating" :label="creatingTitle" />

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">      

      <div class="ui segment">
        <h4 class="ui dividing header">Dados do Grupo</h4>
        <div class="ui form">          
          <div class="fields">            
            <div class="seven wide field">
              <label class="form-label">Nome <span class="red text">*</span></label>
              <input class="uppercase" v-model="group.name" @blur="group.name = $toUpperCase($event)">
            </div>                                              
          </div>         
        </div>
      </div>  

      <div class="ui segment form-segment">

        <h4 class="ui dividing header">Usuários</h4>
        
        <div class="ui form">
          <div class="fields">
            <div class="seven wide field">
              <user-picker ref="userPicker" @onPick="onPickUser" />
            </div>
          </div>
        </div>        
        
        <table v-if="hasUsers" class="ui celled selectable tablet stackable table animated fadeIn">
          <thead v-if="$isDesktop">
            <tr>
              <th>Nome</th>
              <th>Perfil</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(user, index) in group.users">
              <td>
                <strong class="mobile-only">Nome: </strong> {{ user.name + ' ' + user.lastName }}                  
              </td>
              <td>
                <strong class="mobile-only">Perfil: </strong> 
                <user-group-icon :group="user.group" />
                {{ user.groupName }}                  
              </td>
              <td style="width: 50px;">
                <button class="ui small icon button" @click="group.users.splice(index, 1)">
                  <i class="times icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-20 animated fadeIn">
          <i class="info circle icon"></i> Nenhum usuário associado
        </p>

      </div>

      <div class="m-t-20">
        <button class="ui basic button" @click="goBack()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="isUpdating" class="ui basic red button m-l-10" 
          :class="{ loading: removing }" @click="$refs.confirmRemovalModal.show()">
          <i class="trash icon"></i> Excluir
        </button> 
        <button class="ui right floated blue button" :class="{ loading: saving }" @click="onConfirm()">
          <i class="check icon"></i> {{ isCreating ? 'Confirmar' : 'Atualizar' }}
        </button>         
      </div>

      <yes-no-modal ref="confirmRemovalModal" danger="true"
        :message="`Confirma exclusão do grupo ${group.name} ?`"  @onYes="onConfirmRemoval()" />

    </div>
  
  </div>  
  
</template>

<script>
    
  import UserGroupService from "@/services/user-group-service"  
  import { UserGroupIcon, UserPicker } from "@/components"
  import { formPage, onlySimavet } from "@/mixins"

  export default {
    
    name: "UserGroupForm",

    mixins: [formPage, onlySimavet],

    data() {
      return {
        indexRoute: "/admin/user-groups",
        creatingTitle: "Novo Grupo de Usuários",
        updatingTitle: "Alterar Grupo de Usuários",
        service: new UserGroupService(),
        group: { users: [] },        
      }
    },    

    components: {
      UserPicker,
      UserGroupIcon,
    },

    created() {
      
      this.initFormPage()

      if (this.isUpdating)
        this.loadGroup()      
    },    

    computed: {

      hasUsers() {
        return (this.group.users.length > 0)
      },
    },

    methods: {

      async loadGroup() {

        this.loading = true

        try {

          this.group = await this.service.findById(this.$route.params.id)

        } catch (error) {          

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onPickUser(user) {              

        let exists = false

        this.group.users.forEach((el) => {
          if (user.id == el.id)
            exists = true
        })

        if (exists) {
          this.$msg.info("Usuário já associado a essa grupo")
        } else {
          this.group.users.push(this.$cloneObject(user))
        } 

        this.$refs.userPicker.clear()
      },

      async onConfirm() {

        if (!this.validData())
          return

        this.saving = true

        try {

          if (this.isCreating) {
            await this.service.create(this.group)
          } else {
            await this.service.update(this.group)
          }

          this.$reloadDataTables(["user-groups"])

          this.$msg.success(this.isCreating ? "Grupo criado com sucesso" : "Grupo atualizado com sucesso")

          this.goBack()

        } catch (error) {

          this.saving = false

          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.group.name) {
          message = "Informe o nome do grupo"
        } else if (!this.hasUsers) {
          message = "Nenhum usuário associado"
        }

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      async onConfirmRemoval() {
        
        this.removing = true

        try {

          await this.service.remove(this.group)

          this.$reloadDataTables(["user-groups"])

          this.$msg.success("Grupo excluído com sucesso")

          this.goBack()

        } catch (error) {

          this.removing = false

          this.$errorHandler(error)
        }
      }
    },
  }

</script>

